import type { QuestionnaireResponseItem } from "@medplum/fhirtypes";

import {
  LABOR_VITALS_BLOOD_PRESSURE_LINK_ID,
  LABOR_VITALS_ROOT_LINK_ID,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/labor-vitals/constants/labor-vitals-link-ids";
import { findQuestionnaireResponseItem } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/questionnaire-response-readers";

/**
 * Resolves the labor vitals questionnaire response root group.
 * Prefers linkId `laborVitals`; falls back to item[0] only when that group contains
 * `bloodPressure` so an unrelated first item is not treated as the vitals root.
 */
export function resolveLaborVitalsRootGroup(
  items: QuestionnaireResponseItem[] | undefined,
): QuestionnaireResponseItem | undefined {
  const rootByLinkId = findQuestionnaireResponseItem(items, LABOR_VITALS_ROOT_LINK_ID);
  if (rootByLinkId) {
    return rootByLinkId;
  }

  const firstItem = items?.[0];
  if (
    firstItem &&
    findQuestionnaireResponseItem(firstItem.item, LABOR_VITALS_BLOOD_PRESSURE_LINK_ID)
  ) {
    return firstItem;
  }

  return undefined;
}
